import * as z from "zod";
import { grantsForScope } from "../rbac/grantQueries";
import {
  assertCustomRoleScope,
  assertIdpSyncNotActive,
  grantEntry,
  validateUserGroupGrants,
} from "../rbac/validation";
import { reconcileGroupUserGrants } from "../rbac/userGroups";
import { monitoringAnalytics } from "./monitoringAnalytics";
import { mutator } from "./mutator";

export const setGroupGrants = mutator({
  stripKeys: { analytics: Object.keys(monitoringAnalytics.shape) },
  schema: z.object({
    analytics: monitoringAnalytics.optional(),
    userGroupId: z.string(),
    grants: z.array(grantEntry),
  }),
  resolve: {
    userGroup: { kind: "userGroup", from: "userGroupId" },
    grantUsers: { kind: "user", from: "grants", field: "userId" },
    grantCustomRoles: {
      kind: "role",
      from: "grants",
      field: "customRoleId",
    },
  },
  permissions: [
    {
      permission: "user_group:write",
      scopeId: ({ args }) => args.userGroup.id,
    },
  ],
  fn: async ({ tx, ctx, args: { userGroup, grants, grantCustomRoles } }) => {
    await assertIdpSyncNotActive(tx, ctx.tenantId, "groupMembership");

    validateUserGroupGrants(grants, "user_group");
    for (const role of grantCustomRoles) {
      assertCustomRoleScope(role, "user_group");
    }

    const allExisting = await tx.run(
      grantsForScope(userGroup.id, userGroup.tenantId)
    );
    await reconcileGroupUserGrants(
      tx,
      [
        {
          groupId: userGroup.id,
          existing: allExisting.filter((g) => g.userId),
          desired: grants,
        },
      ],
      ctx.tenantId
    );
  },
});
